// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"cab7c4b9","729":"7c5026b6"}[chunkId] + ".css";
};